import { observer } from 'mobx-react-lite';
import React, { FormEvent, useContext, useState} from 'react';
import { Button, Divider, Feed, Form, Header, Popup, Rail, Segment, Tab } from 'semantic-ui-react';
import { IProjectNote } from '../../../app/models/projectnote';
import MobileStore from "../../../app/stores/mobileStore";
import { RootStoreContext } from '../../../app/stores/rootStore';

const MobileNotesFeed: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { user } = rootStore.userStore;
  const mobileStore = useContext(MobileStore);
  const {
    project,
    projectnotesByDate,
    createProjectNote,
    deleteProjectNote,
    updateProjectNote,
    target,
    submitting,
  } = mobileStore;

  const [projectnote, setProjectnote] = useState<IProjectNote>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: project!.id,
    admin: user!.displayName,
    status: "",
    notes: "",
  });

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectnote({ ...projectnote, [name]: value });
  };

  return (
    <Segment>
      <Header>
      Notes
      <Button
          loading={submitting}
          floated="right"
          positive
          onClick={()=> createProjectNote(projectnote)}
          content="Submit"
          size="mini"
        />
      </Header>
      
      <Form>
        <Form.TextArea
          onChange={handleInputChange}
          name="notes"
          rows={2}
          placeholder="Notes"
          value={projectnote.notes}
        />
      </Form>

      <Feed>
    {projectnotesByDate.map((note) => (
      <>
      <Feed.Event>
      <Feed.Content>
        
        <Feed.Summary>
        <Feed.User>{note.admin}</Feed.User>
        <Popup trigger={<span> added a note</span>} flowing hoverable>
          <div>
          Want to remove the note? Click &nbsp;
                <Button
                    name={note.id}
                    size="mini"
                    onClick={() => deleteProjectNote(note)}
                    content="Delete"
                    color="red"
                  />
          </div>
          <div>
          Mark as a to-do item? Click &nbsp;
                <Button
                    name={note.id}
                    size="mini"
                    onClick={() => updateProjectNote(note.id, "To-Do")}
                    content="To-Do"
                    color="blue"
                  />
          </div>
          <div>
          Already finished the to-do item? Click &nbsp;
                <Button
                    name={note.id}
                    size="mini"
                    onClick={() => updateProjectNote(note.id, "Done")}
                    content="Done"
                    color="green"
                  />
          </div>
        </Popup>
        <Feed.Date>{note.createdAt.substring(0,19).replace("T", " ")}</Feed.Date>
        </Feed.Summary>
        <Feed.Extra text>
        {(note.status === "To-Do") ? <span style={{color: "red"}}> {note.notes} </span> : 
          (note.status === "Done") ? <span style={{color: "green"}}> {note.notes} </span> :
          note.notes
         }
        </Feed.Extra>
        <Feed.Meta>
         {(note.status === "To-Do") ? <strong style={{color: "red"}}> {note.status} </strong> : 
          (note.status === "Done") ? <strong style={{color: "green"}}> {note.status} </strong> :
          ""
         }
        </Feed.Meta>
      </Feed.Content>
      
      </Feed.Event>
      <Divider fitted/>
      </>
    ))}
    
    </Feed>
    </Segment>
  );
};

export default observer(MobileNotesFeed);
